// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2ioAP","content":"GlobalSearch_content__Jqmgf"};